import { SettingsManager } from "@viamap/viamap2-common/dist/managers/SettingsManager";
import { BestemtFastEjendom, BygningPaaFremmedGrundFlade, BygningPaaFremmedGrundPunkt, Ejerlejlighed, SamletFastEjendom } from "./Mat2Types";

export class mat2Collector {

   /**
    * Get property information for a specific BFE number or an array of BFE numbers.
    * @param bfe - BFE number or array of BFE numbers
    * @returns A promise that resolves to an object containing property information for the specified BFE(s).
    */
   static async getEjendomme(bfe: number | string): Promise<undefined | Mat2Feature>
   static async getEjendomme(bfe: number[] | string[]): Promise<{ [key: string]: Mat2Feature | undefined }>
   static async getEjendomme(bfe: string | string[] | number | number[]): Promise<{ [key: string]: any } | undefined> {
      let bfeList = Array.isArray(bfe) ? bfe.map((b) => b.toString()) : [bfe.toString()];
      let res = {};
      let response = await fetchMat(bfeList.join("|"));
      let asList = Mat2ReturnToFeature(response)
      if (!Array.isArray(bfe)) {
         return asList.length > 0 ? asList[0] : undefined;
      }
      bfeList.forEach((b) => {
         const found = asList.find((a) => String(a.BFEnummer) == b)
         res[b.toString()] = found ? found : undefined;
      });
      return res;
   }

}

export type Mat2Feature =
   | (SamletFastEjendom["features"][0]["properties"] & { type: "SFE" })
   | (Ejerlejlighed["features"][0]["properties"] & { type: "EJL" })
   | (BygningPaaFremmedGrundFlade["features"][0]["properties"] & { type: "BPFG" })
   | (BygningPaaFremmedGrundPunkt["features"][0]["properties"] & { type: "BPFG" })

function Mat2ReturnToFeature(data: BestemtFastEjendom): Mat2Feature[] {
   const sfe = data.SamletFastEjendom?.features.map((f) => ({ ...f.properties, type: "SFE" })) as (SamletFastEjendom["features"][0]["properties"] & { type: "SFE" })[] | undefined;
   const bfe = data.Ejerlejlighed?.features.map((f) => ({ ...f.properties, type: "EJL" })) as (Ejerlejlighed["features"][0]["properties"] & { type: "EJL" })[] | undefined;
   const bpfg_p = data.BygningPaaFremmedGrund?.BygningPaaFremmedGrundPunkt?.features.map((f) => ({ ...f.properties, type: "BPFG" })) as (BygningPaaFremmedGrundPunkt["features"][0]["properties"] & { type: "BPFG" })[] | undefined;
   const bpfg_f = data.BygningPaaFremmedGrund?.BygningPaaFremmedGrundFlade?.features.map((f) => ({ ...f.properties, type: "BPFG" })) as (BygningPaaFremmedGrundFlade["features"][0]["properties"] & { type: "BPFG" })[] | undefined;
   return [...(sfe ?? []), ...(bfe ?? []), ...(bpfg_p ?? []), ...(bpfg_f ?? [])];
}

function fetchMat(bfeNr: string) {
   const serviceUrl = "https://services.datafordeler.dk/Matriklen2/Matrikel/2.0.0/rest/BestemtFastEjendom";
   const params = {
      BFEnr: bfeNr,
      username: SettingsManager.getSystemSetting("datafordelerUsername"),
      password: SettingsManager.getSystemSetting("datafordelerPassword"),
   }
   return fetch(serviceUrl + `?${new URLSearchParams(params)}`, {
      method: 'GET',
      headers: {
         'Accept': 'application/json'
      }
   }).then(async res => {
      if (!res.ok) {
         await res.text().then(text => {
            console.error("Error response from Mat2:", text);
         });
         throw new Error(`HTTP error! status: ${res.status}`);
      }
      return res.json() as Promise<BestemtFastEjendom>;
   });
}
